import React from 'react';
import {  Table,message ,Tag, Divider,Button,Form,Input,Select, DatePicker} from 'antd';
import BreadcrumbCustomer from "../breadcrumb";
import storage from '../../utils/storage';
import { configs } from '../../config/config';
import { exportUserActivityList, getUserActivityList } from '../../model/operation/requests';
import { dbFields } from '../../model/operation/column';
import { addKey } from '../../utils/utils';
import * as XLSX from "xlsx"

const {Option} = Select;
const  {RangePicker} = DatePicker;


class OperationLogs extends React.Component {
  formRef = React.createRef();
    constructor(props){
        super(props)
        this.state = {
            data:[],
            filterDate:[],
            filterEmail:""
        }

        this.columns = [
            {
                title: dbFields.id.title,
                dataIndex: dbFields.id.key,
                key: dbFields.id.key,
              },
              {
                title: dbFields.req.title,
                dataIndex: dbFields.req.key,
                key: dbFields.req.key,
              },
              {
                title: dbFields.type.title,
                dataIndex: dbFields.type.key,
                key: dbFields.type.key,
                filters: [
                    {
                      text: 'Request',
                      value: false,
                    },
                    {
                      text: 'Response',
                      value: true,
                    },
                  ],
                onFilter: (value, record) => record.type == value,
                render:(item)=>(
                    <>
                        <Tag color={item == 0 ? 'green' : 'blue'}>
                        {item === 0 ? "Request" : "Response"}
                        </Tag>
                    </>
                )
              },
            {
              title: dbFields.name.title,
              dataIndex: dbFields.name.key,
              key: dbFields.name.key,
            },
            {
                title: dbFields.method.title,
                dataIndex: dbFields.method.key,
                key: dbFields.method.key,
                filters: [
                    {
                      text: 'GET',
                      value: "GET",
                    },
                    {
                      text: 'POST',
                      value: "POST",
                    },
                    {
                        text: 'DELETE',
                        value: "DELETE",
                      },
                      {
                        text: 'PUT',
                        value: "PUT",
                      },
                  ],
                  onFilter: (value, record) => record.methods == value,
                  filterMultiple: true,
              },
              {
                title: dbFields.module.title,
                dataIndex: dbFields.module.key,
                key: dbFields.module.key,
              },
              {
                title: dbFields.action.title,
                dataIndex: dbFields.action.key,
                key: dbFields.action.key,
              },
              {
                title: dbFields.createdAt.title,
                dataIndex: dbFields.createdAt.key,
                key: dbFields.createdAt.key,
              },
          ];
    }

    handlerSearch = (e) =>{
      let start = this.state.filterDate.length ==2 ? this.state.filterDate[0] : "";
      let end = this.state.filterDate.length ==2 ? this.state.filterDate[1] : "";
      let email =  this.formRef.current.getFieldValue('email')
      let dataList = []

      getUserActivityList({start:start,end:end,name:email}).then(res=>{
        if(res.data.code == 200){
            dataList =   addKey(res.data.data)
            this.setState({
                data:dataList
            })
        }else{
            message.warn(res.data.msg)
        }
      }).catch(err=>{
          message.error(err)
      })



    }

    handlerDateChange = (date,dtString) =>{
      this.setState({
          filterDate:dtString
      })
  }

    componentDidMount(){
                // load data 
                let dataList = []
                getUserActivityList({start:"",end:"",email:""}).then(res=>{
                    if(res.data.code == 200){
                        dataList =  addKey(res.data.data)
                        this.setState({
                            data:dataList
                        })
                    }else{
                        message.warn(res.data.msg)
                    }
                }).catch(err=>{
                    message.error(err)
                })
    }


    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    handlerExport = ()=>{
      let start = this.state.filterDate.length ==2 ? this.state.filterDate[0] : "";
      let end = this.state.filterDate.length ==2 ? this.state.filterDate[1] : "";
      let email =  this.formRef.current.getFieldValue('email')

      exportUserActivityList({start:start,end:end,name:email}).then(res=>{
        if(res.data.code == 200){
          const data = res.data.data; // 假设后端返回的数据是一个数组
          // 检查响应数据格式
          if (!Array.isArray(data)) {
              throw new Error('数据格式不正确');
          }

          const customHeaders = [
            { header: 'ID', key: 'id' },
            { header: 'Name', key: 'name' },
            { header: 'ReqId', key: 'req_id' },,
            { header: 'Type', key: 'type' },
            { header: 'Module', key: 'modules' },
            { header: 'Action', key: 'actions' },
            { header: 'Ip', key: 'ip' },
            { header: 'Date', key: 'date' },
            { header: 'GroupName', key: 'group_name' },

        ];


          // 将数据转换为工作表
          const worksheet = XLSX.utils.json_to_sheet(data);

           // 设置表头
           const headerRow = customHeaders.map(header => header.header);
           XLSX.utils.sheet_add_aoa(worksheet, [headerRow], { origin: 'A1' });

           // 将数据填充到工作表中
           const dataRow = data.map(item => ({
               id: item.id,
               name: item.name,
               value: item.value
           }));
           XLSX.utils.sheet_add_json(worksheet, dataRow, { header: customHeaders.map(h => h.key), skipHeader: true, origin: 'A2' });

           // 创建工作簿
           const workbook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');


          // 生成 Excel 文件
          const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

          // 创建 Blob 对象
          const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'data.xlsx'); // 设置下载文件名
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
      }else{
          message.warn(res.data.msg)
      }

      }).catch(err=>{
          console.log(err)
          message.error(err)
      })

    }
    
  

    // downloadExcel = async () => {
    //   try {
    //        const response = await axios.post(Api.operation.export, {
    //           responseType: 'blob', // 指定响应类型为 blob
    //       });

    //       // 创建一个 Blob URL
    //       console.log(response)
    //       const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/x-excel'}));
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.setAttribute('download', 'data.xls'); // 设置下载文件名
    //       document.body.appendChild(link);
    //       link.click();
    //       link.parentNode.removeChild(link); // 移除链接
    //   } catch (error) {
    //       console.error('Error downloading the file:', error);
    //   }
    // }
    render(){
        const {data} = this.state
        return(
            <>
             <BreadcrumbCustomer first='Operation Records' second='' />
             <Form  name="horizontal_login" layout="inline"  ref={this.formRef} >
                <Form.Item
                    name="date"
                >
                   <RangePicker 
                    onChange={this.handlerDateChange}
                    format="YYYY-MM-DD" />
                </Form.Item>
                <Form.Item name="email">
                  <Input placeholder='Please Input The Email '/>
                </Form.Item>
                    <Form.Item shouldUpdate>
                      <Button
                          type="primary"
                          style={{background: "#851dd6",color:"white" }}
                          onClick={this.handlerSearch}
                      >

                        Filter
                    </Button>
     
                    </Form.Item>
                    <Form.Item shouldUpdate>
                      <Button
                          type="primary"
                          style={{background: "#851dd6",color:"white" }}
                          onClick={this.handlerExport}
                      >
                        Export
                    </Button>
     
                    </Form.Item>
            </Form> 

             <Divider />
             <Table dataSource={data} columns={this.columns}  />

            </>
        )
    }
}

export default OperationLogs;